import React from "react";

import LandingHeader from "pages/landing/includes/LandingHeader";
import LandingFooter from "pages/landing/includes/LandingFooter";

const SITE_EMAIL = process.env.REACT_APP_SITE_EMAIL;

class Contact extends React.Component {

    render() {
        return (
            <>
                <LandingHeader />
                
                <div className="breadcrumb-area shadow dark bg-fixed text-center text-light" style={{"backgroundImage": "url(assets/edocom/img/banner/4.jpg)"}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <h1>Contact Us</h1>
                                <ul className="breadcrumb">
                                    <li><a href="#/"><i className="fas fa-home"></i> Home</a></li>
                                    <li className="active">Contact Us</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="contact-info-area default-padding">
                    <div class="container">
                        <div class="contact-info text-center">
                            <div class="row">
                                <div class="col-md-4 col-sm-4">
                                    <div class="item">
                                        <div class="icon">
                                            <i class="flaticon-call"></i>
                                        </div>
                                        <div class="info">
                                            <h4>Call Us</h4>
                                            <span>+91 7477893990</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-4">
                                    <div class="item">
                                        <div class="icon">
                                            <i class="flaticon-location"></i>
                                        </div>
                                        <div class="info">
                                            <h4>Address</h4>
                                            <span>Gurgaon, India</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-4">
                                    <div class="item">
                                        <div class="icon">
                                            <i class="flaticon-email"></i>
                                        </div>
                                        <div class="info">
                                            <h4>Email Us</h4>
                                            <span>{SITE_EMAIL}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h4>
                            For any queries feel free to write to us at the email provided. We shall be glad to hear from you!
                        </h4>
                    </div>
                </div>

                

                <LandingFooter />
            </>
        );
    }
}

export default Contact;
